import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Flex } from '../../layout';

type IDividerVariant = 'solid' | 'dashed';
type IDividerOrientation = 'horizontal' | 'vertical';

interface IDividerProps extends HTMLAttributes<HTMLHRElement> {
  containerClassName?: string;
  orientation?: IDividerOrientation;
  text: string;
  variant?: IDividerVariant;
}

export function DividerWithText({
  className,
  containerClassName,
  orientation = 'horizontal',
  text = 'Divider',
  variant = 'solid',
  ...rest
}: IDividerProps) {
  return (
    <Flex className={twMerge('items-center', containerClassName)}>
      <hr
        className={classNames(
          twMerge(`flex-1 border-t border-gray-300 h-[1px] my-3`, className),
          {
            'border-solid': variant === 'solid',
            'border-dashed': variant === 'dashed',
            'rotate-90': orientation === 'vertical',
          },
        )}
        {...rest}
      />
      <span className="w-fit mx-4 text-base font-medium whitespace-nowrap">
        {text}
      </span>
      <hr
        className={classNames(
          twMerge(`flex-1 border-t border-gray-300 h-[1px] my-3`, className),
          {
            'border-solid': variant === 'solid',
            'border-dashed': variant === 'dashed',
            'rotate-90': orientation === 'vertical',
          },
        )}
        {...rest}
      />
    </Flex>
  );
}
